__turbopack_context__.v({
  "desktopFiltersWrapper": "style-module-scss-module__3ObuCq__desktopFiltersWrapper",
  "emptyResult": "style-module-scss-module__3ObuCq__emptyResult",
  "filtersButton": "style-module-scss-module__3ObuCq__filtersButton",
  "filtersButtonOpen": "style-module-scss-module__3ObuCq__filtersButtonOpen",
  "filtersCount": "style-module-scss-module__3ObuCq__filtersCount",
  "grid": "style-module-scss-module__3ObuCq__grid",
  "head": "style-module-scss-module__3ObuCq__head",
  "line": "style-module-scss-module__3ObuCq__line",
  "plusIcon": "style-module-scss-module__3ObuCq__plusIcon",
  "showMoreButton": "style-module-scss-module__3ObuCq__showMoreButton",
  "showMoreButtonWrapper": "style-module-scss-module__3ObuCq__showMoreButtonWrapper",
  "title": "style-module-scss-module__3ObuCq__title",
  "wrapper": "style-module-scss-module__3ObuCq__wrapper",
});
